<template>
  <section class="container">
    <!-- Vista seleccionar usuarios -->
    <div class="section__users">
      <!-- <p class="title-agents">Usuarios</p> -->
      <div class="box" :style="styleBox">
        <div class="container__search">
          <!-- <a-checkbox
            @change="handleSelectAllActiveUsers($event)"
            :checked="allItemsSelected"
            class="checkbox__select"
          >
            Seleccionar todo
          </a-checkbox> -->
          <a-input
            placeholder="Busca los usuarios aquí"
            class="search__users"
            @change="handleSearchActiveUsers"
          >
            <template #suffix>
              <SearchOutlined style="color: #8c8c8c" />
            </template>
          </a-input>

          <div class="container__search--select-all" v-if="isSelectAll">
            <h3>Lista de usuarios ({{ getActiveUsers.length }})</h3>
            <a-checkbox
              @change="handleSelectAllActiveUsers($event)"
              :checked="allItemsSelected"
              :indeterminate="someItemsSelected && !allItemsSelected"
              :disabled="disabledAll"
              class="checkbox__select"
            >
              Seleccionar todos
            </a-checkbox>
          </div>
        </div>
        <div id="style-scroll-agente" class="scrollbar-agent">
          <div>
            <a-spin :spinning="loading">
              <div style="min-height: 50px">
                <div class="container-items-agent" v-if="profilesGroup">
                  <div
                    v-for="profileName in Object.keys(profilesGroup)"
                    :key="profileName"
                    class="item__agent"
                  >
                    <div
                      v-if="
                        profilesGroup[profileName].some((user) =>
                          user.fullname.toLowerCase().includes(searchText)
                        )
                      "
                      style="padding-right: 0"
                    >
                      <!-- <a-checkbox
                        :checked="allItemsSelectedByProfile(profileName)"
                        @change="handleSelectActiveUsersByProfile($event, profileName)"
                        > -->
                      <div
                        :class="isSelectAll ? 'item__agent--select-all' : ''"
                      >
                        <span class="profile__name">
                          {{ profileName }}
                        </span>
                        <a-checkbox
                          :checked="allItemsSelectedByProfile(profileName)"
                          :indeterminate="
                            thereAreItemsSelectedByProfile(profileName) &&
                            !allItemsSelectedByProfile(profileName)
                          "
                          :disabled="disabledItemsByProfile(profileName)"
                          @change="handleSelectActiveUsersByProfile($event, profileName)"
                          class="checkbox__select"
                        >
                          Seleccionar todos
                        </a-checkbox>
                      </div>
                      <!-- </a-checkbox> -->
                    </div>
                    <div
                      v-for="user in orderedSubUsers(profilesGroup[profileName])"
                      :key="user.id"
                      :class="
                        user.fullname.toLowerCase().includes(searchText) === false
                          ? 'container__hide'
                          : 'container__users'
                      "
                    >
                      <template
                        class="item__template"
                        v-if="user.fullname.toLowerCase().includes(searchText)"
                      >
                        <div style="display: flex">
                          <div v-if="user?.picture">
                            <img class="user__icon" :src="user?.picture" alt="perfil" />
                          </div>
                          <div
                            v-else
                            :class="user?.role === 'Agente' ? 'background__agent' : ''"
                            class="background__profile"
                          >
                            <img
                              v-if="user.icon"
                              class="user__profile"
                              :class="user.role === 'Agente' ? 'user__agente' : ''"
                              :src="getProfileImage(user?.icon || iconDefault)"
                              alt="perfil"
                            />
                          </div>
                          <a-tooltip placement="top">
                            <template #title v-if="user.fullname?.length > 21">
                              {{ user.fullname }}
                            </template>
                            <p class="text__name">
                              {{ user.fullname }}
                            </p>
                          </a-tooltip>
                        </div>
                        <p class="text__rol" v-if="viewRol">
                          Rol: {{ profileName }}
                        </p>

                        <div style="display: flex; gap: 20px">
                          <a-tag :color="user.status == 1 ? 'success' : 'error'">
                            {{ user.status == 1 ? 'Activo' : 'Inactivo' }}
                          </a-tag>
                          <a-checkbox
                            :checked="user.added"
                            :disabled="user.disabled"
                            @change="handleSelectSingleActiveUser($event, user.id)"
                            class="container__flex"
                          ></a-checkbox>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </a-spin>
          </div>
        </div>
      </div>
    </div>
    <!-- Vista usuarios seleccionados -->
    <!-- <div class="section__users--selected">
      <p class="title-agents">Seleccionados</p>
      <a-spin :spinning="loading">
        <div class="box">
          <div class="container__information" v-if="!someItemsSelected">
            <img :src="squareImage" alt="empty" />
            <p class="infoUser">Aquí se visualizará los usuarios que vaya seleccionando.</p>
          </div>
          <div id="style-scroll-agente" class="scrollbar-agent">
            <div
              v-for="profileName in Object.keys(profilesGroup)"
              :key="profileName"
              class="container__selected"
            >
              <div :class="{ container__profile: user?.added }">
                <span class="profile__name" v-if="thereAreItemsSelectedByProfile(profileName)">
                  {{ profileName }}
                </span>
              </div>
              <div
                v-for="user in profilesGroup[profileName]"
                :key="user.id"
                :class="{ selectedGroup: user.added }"
              >
                <template v-if="user.added">
                  <div>
                    <a-tooltip placement="top">
                      <template #title>
                        <span v-if="user.fullname?.length > 21">{{ user.fullname }}</span>
                      </template>
                      <p class="text__name">
                        {{ user.fullname }}
                      </p>
                    </a-tooltip>
                  </div>
                  <div class="container__flex">
                    <div v-if="user?.picture">
                      <img class="user__icon" :src="user?.picture" alt="perfil" />
                    </div>
                    <div
                      v-else
                      :class="user?.role === 'Agente' ? 'background__agent' : ''"
                      class="background__profile"
                    >
                      <img
                        v-if="user.icon"
                        class="user__profile"
                        :class="user.role === 'Agente' ? 'user__agente' : ''"
                        :src="getProfileImage(user?.icon || iconDefault)"
                        alt="perfil"
                      />
                    </div>
                    <a href="#" :parent-id="user.id">
                      <CloseOutlined
                        class="icon--close"
                        @click.stop.prevent="handleSelectSingleActiveUser($event, user.id)"
                      />
                    </a>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </a-spin>
    </div> -->
  </section>
</template>

<script>
import { SearchOutlined, CloseOutlined } from "@ant-design/icons-vue";
import { defineComponent } from "vue";

import squareImage from "@/app/entities/assets/square.svg?url";

export default defineComponent({
  components: {
    CloseOutlined,
    SearchOutlined,
  },
  props: {
    record: {
      type: Object,
      required: true,
    },
    strategy: {
      required: true,
      type: Object,
    },
    isSelectAll: {
      required: false,
      default: false,
      type: Boolean,
    },
    viewRol: {
      required: false,
      default: true,
      type: Boolean,
    },
    styleBox: {
      required: false,
      default: null,
      type: String,
    },
    isConfigPlan: {
      required: false,
      default: false,
      type: Boolean,
    },
    disabledAll: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      searchUserList: undefined,
      activeSearch: false,
      checkedItem: false,
      searchText: "",
      loading: false,
      squareImage,
      onecharger: false,
    };
  },
  computed: {
    profilesGroup() {
      let profilesGroups = this.$store.getters["getProfilesGroup"];
      
      return profilesGroups;
      // let profilesGroups = this.$store.getters["getProfilesGroup"];
      // if (!profilesGroups.Owner || !this.isConfigPlan) return profilesGroups;
      // else {
      //   return {
      //     Owner: profilesGroups.Owner.map(el => {
      //       this.$store.dispatch("selectSingleActiveUser", {
      //         status: true,
      //         userId: el.id,
      //       });
      //       return { ...el, disabled: true, added: true }
      //     }),
      //     Administrador:  profilesGroups.Administrador,
      //     ...Object.fromEntries(Object.entries(profilesGroups).filter(([key]) => key !== "Owner" && key !== "Administrador" ))
      //   }
      // }
    },
    getActiveUsers() {
      return this.$store.getters["getActiveUsers"];
      // if (!activeUsers.Owner || !this.isConfigPlan) return activeUsers;
      // else {
      //   return activeUsers.map(el => ({ ...el, disabled: el.is_owner }));
      // }
    },
    allItemsSelected() {
      return !Object.values(this.profilesGroup).some((profileGroup) =>
        profileGroup.some((user) => !user.added)
      );
    },
    someItemsSelected() {
      return Object.values(this.profilesGroup).some((profileGroup) =>
        profileGroup.some((user) => user.added)
      );
    },

    getSelectedIdGroup() {
      return this.$store.getters["getIdSelectedContact"];
    },

    iconDefault() {
      return "smile.svg";
    },
  },
  async created() {
    this.loading = true;

    // await this.$store.dispatch("fetchActiveUsers");
    if (!this.isConfigPlan) {
      await this.$store.dispatch("fetchActiveUsers",500);
    } else {
      await this.$store.dispatch("fetchUsersAllList");
    }
    if (this.record?.id) {
      this.$store.dispatch("fetchSelectedActiveUsers", this.record?.id);
      this.$store.dispatch("fetchAgentPortfolio", this.record?.id);
    }

    this.loading = false;
  },
  methods: {
    orderedSubUsers(users) {
      if (!this.isConfigPlan) {
        const selectedUusers = users
          .filter((profileName) => {
            return profileName.added;
          })
          .sort((a, b) => {
            return a.fullname?.localeCompare(b.fullname);
          });

        const subAgentsWithState1 = users
          .filter((profileName) => {
            return !profileName.added;
          })
          .sort((a, b) => {
            return a.fullname?.localeCompare(b.fullname);
          });
        this.onecharger = true;
        return [...selectedUusers, ...subAgentsWithState1];
      } else {
        const selectedUusers = users
          .filter((profileName) => {
            return profileName.added;
          })
          // .sort((a, b) => {
          //   return a.fullname?.localeCompare(b.fullname);
          // });

        const subAgentsWithState1 = users
          .filter((profileName) => {
            return !profileName.added;
          })
          // .sort((a, b) => {
          //   return a.fullname?.localeCompare(b.fullname);
          // });
        this.onecharger = true;
        return [...selectedUusers, ...subAgentsWithState1];
      }
    },
    getProfileImage(profile) {
      return new URL(`../../../users/assets/profiles/${profile}`, import.meta.url).href;
    },
    allItemsSelectedByProfile(profileName) {
      return !this.profilesGroup[profileName].some((item) => !item.added);
    },
    thereAreItemsSelectedByProfile(profileName) {
      return this.profilesGroup[profileName].some((item) => item.added);
    },
    disabledItemsByProfile(profileName) {
      return !this.profilesGroup[profileName].some((item) => !item.disabled);
    },
    handleSearchActiveUsers(event) {
      this.searchText = event.target.value.toLowerCase();
    },
    handleSelectAllActiveUsers(event) {
      this.$store.dispatch("selectAllActiveUsers", event.target.checked);
    },
    handleSelectActiveUsersByProfile(event, profileName) {
      this.$store.dispatch("selectActiveUsersByProfile", {
        status: event.target.checked,
        profileName,
      });
    },
    handleSelectSingleActiveUser(event, userId) {
      this.$store.dispatch("selectSingleActiveUser", {
        status: event.target.checked,
        userId,
      });
    },
  },
});
</script>

<style lang="sass" scoped>
.container
  display: flex
  box-sizing: border-box
  border-radius: 2px
  justify-content: space-evenly
  .box
    background: $white
    box-sizing: border-box
    display: flex
    flex-direction: column
    height: 60vh

.container__search
  display: flex
  flex-direction: column
  margin-bottom: 10px
  &--select-all
    display: flex
    justify-content: space-between
    align-items: center
    border-bottom: 1px solid #E8E8E8
    margin-top: 15px
    width: 97%
    padding-right: 9px
    h3
      margin-bottom: 0

.checkbox__select
  padding: 8px 0
  font-weight: 400
  display: flex
  flex-direction: row-reverse !important
  color: #00000073

.item__agent
  align-items: center
  margin-bottom: 8px
  &--select-all
    display: flex
    justify-content: space-between
    align-items: center
    border-bottom: 1px solid #E8E8E8
    margin-top: 15px
    // width: 97%
    padding-right: 9px
    h3
      margin-bottom: 0

.title-agents
  margin-bottom: 0px
  font-weight: 600
  color: $gray-9

.selection-agents
  width: 85%
  background: $blue-1
  border: 1px solid $blue-3
  box-sizing: border-box
  border-radius: 3px
  height: 25px
  display: flex
  padding: 1px 8px 1px
  margin: 2px 0px
  justify-content: space-between
  margin-left: 40px
  margin-top: 10px
input[type="checkbox"]
  width: 16px
  height: 16px
  margin-right: 8px
input:checked
  background-color: $blue-6
  &:hover
    background-color: $blue-6

.scrollbar-agent
  float: left
  overflow-y: scroll
  padding-right: 10px

.label-agent
  padding-left: 7px
  display: flex
  align-items: center

#style-scroll-agente::-webkit-scrollbar-track
  border-radius: 10px
  background-color: $white
#style-scroll-agente::-webkit-scrollbar
  width: 5px
  background-color: $white
#style-scroll-agente::-webkit-scrollbar-thumb
  border-radius: 10px
  background-color: #C4C4C4

.section__users
  margin-right: 12px
  width: 100%

.icon--close
  color: $gray-8
  margin-left: 5px

.section__users--selected
  width: 45%

// .checkbox__select
//   border-bottom: 1px solid #E8E8E8
//   margin-bottom: 10px
//   padding: 8px 12px

.search__users
  width: 97%
  margin-top: -5px

.container__users
  display: flex
  align-items: center
  justify-content: space-between
  border: 1px solid $gray-4
  box-sizing: border-box
  border-radius: 10px
  padding: 10px
  margin-top: 10px

.container__hide
  margin-top: 10px

.profile__name
  margin-left: 7px
  font-weight: 600

.user__icon
  width: 26px
  height: 26px
  margin: 6px
  border-radius: 50%

.user__profile
  width: 17px
  height: 17px
  margin: 6px
  filter: invert(62%) sepia(84%) saturate(1521%) hue-rotate(178deg) brightness(103%) contrast(99%)

.user__agente
  width: 17px
  height: 17px
  margin: 6px
  filter: invert(55%) sepia(46%) saturate(1606%) hue-rotate(351deg) brightness(105%) contrast(96%)

.container__selected
  margin-top: 20px
  margin-left: 10px

.container__profile
  border-bottom: 1px solid #E8E8E8

.selectedGroup
  width: 85%
  background: #e6f7ff
  border: 1px solid #91d5ff
  box-sizing: border-box
  border-radius: 3px
  height: 36px
  display: flex
  padding: 1px 8px 1px
  margin: 2px 0
  justify-content: space-between
  margin-left: 40px
  margin-top: 10px
  align-items: center

.container__image
  margin-right: 10px

.container__information
  margin: 0 auto
  text-align: center
  margin-top: 90px

.infoUser
  margin-top: 40px
  color: $gray-6

.text__name
  overflow: hidden
  white-space: nowrap
  text-overflow: ellipsis
  padding-left: 10px
  margin-right: 4px
  width: 150px
  margin-bottom: 0
  display: flex
  align-items: center

.container__flex
  display: flex
  align-items: center

.background__profile
  background-color: rgb(230, 247, 255)
  border-radius: 50%
  display: flex
  align-items: center
  margin-right: 3px
  height: 32px

.background__agent
  background: #FFF6E2
  border-radius: 50%
  display: flex
  align-items: center
  margin-right: 3px
  height: 32px

.item__template
  display: flex
  justify-content: space-between
  border-radius: 10px
  align-items: center
  /*margin-left: 20px */
  margin-bottom: 10px
  padding: 5px 10px
  border: 1px solid $gray-4

.text__rol
  color: $gray-6
</style>
